import React from 'react';
import Text from '../Text/index.js';

/**
 *  Styles Advertising text consistently
 *
 */
function AdvertisementText(_ref) {
  let {
    children = ['Advertisement'],
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Text, Object.assign({}, rest, {
    color: "subdued-lightest",
    size: 100
  }), children);
}
export default AdvertisementText;